export default class VueWarnException extends Error {
  constructor(message) {
    super(message);

    this.name = 'VueWarnException';
  }
}



// WEBPACK FOOTER //
// ./src/exceptions/VueWarnException.js